module.exports = __webpack_public_path__ + "media/Collision-free-and-Spill-proof.087d2092.mp4";